import RestfulProvider from "./http";
import http from "./http";

const signin = (params) => {
  return RestfulProvider.post("/api/user-admin-login", params);
};
const get_customer = (params) => {
  return RestfulProvider.post("/api/get-customer", params);
};

const punch = (params) => {
  return RestfulProvider.post("/api/create-punch", params);
};
const getTodayStatus = (params) => {
  return RestfulProvider.post("/api/get-today-status", params);
};

const getAdminDetails = (params) => {
  return RestfulProvider.post("/api/get-admin", params);
};

const getAttendanceByDateRange = (params) => {
  return RestfulProvider.post("/api/get-attendance-by-date-range", params);
};

const getleaveTypes = (params) => {
  return RestfulProvider.get("/api/get-leave-types", params);
};

const getActiveGlobalHolidays = (data) => {
  return RestfulProvider.get(`/api/get-active-holiday/${data}`);
};
const createLeave = (data) => {
  return RestfulProvider.post(`/api/create-leave`, data);
};
const getLeaves = (data) => {
  return RestfulProvider.post(`/api/get-leave-auth`, data);
};

const getJobs = (data) => {
  return RestfulProvider.post(`/api/my-jobs`, data);
};

const getMyJobs = (data) => {
  return RestfulProvider.post(`/api/my-jobs`, data);
};

const changeStatus = (id, data) => {
  const isFormData = data instanceof FormData;
  return RestfulProvider.post(`/api/jobs/${id}/change-status`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
  });
};

const attendanceregularization = (data) => {
  return RestfulProvider.post(`/api/attendanceregularization`, data); // Fixed URL
};

const getAttendanceRegularizationById = (id) => {
  return RestfulProvider.get(`/api/attendance-regularization/{id}'`);
};

const approveAttendanceRegularization = (id, data) => {
  return RestfulProvider.post(`/api/approve-attendance-regularization/${id}`, data);
};

const denyAttendanceRegularization = (id, data) => {
  return RestfulProvider.post(`/api/deny-attendance-regularization/${id}`, data);
};

const getRegularizationList = (params) => {
  return RestfulProvider.post('/api/get-regularization-list', params);
};

const getSiteAttendanceByDate = (params) => {
  return RestfulProvider.post('/api/get-site-attendance-by-date', params);
};

const getAttendanceById = ({ id }) => {
  return RestfulProvider.get(`/api/attendance/${id}`);
};

const configService = {
  signin,
  getLeaves,
  createLeave,
  get_customer,
  punch,
  getTodayStatus,
  getAdminDetails,
  getAttendanceByDateRange,
  getleaveTypes,
  getActiveGlobalHolidays,
  getJobs,
  getMyJobs,
  changeStatus,
  attendanceregularization,
  getAttendanceRegularizationById,
  approveAttendanceRegularization,
  denyAttendanceRegularization,
  getRegularizationList,
  getSiteAttendanceByDate,
  getAttendanceById,
};

export default configService;